import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

type getPSBProps = {
    tomos: any[],
    volumes: any[],
}

const getPSB = async(dam_uuid: string, values: getPSBProps): Promise<any | Error> => {
    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post(`/psb?uuid=${dam_uuid}`, values, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json', 
            },
            responseType: 'blob', 
        });

        if (response) {
            return response;
        }

        return new Error('Erro ao buscar registros.');

    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao buscar registros.');
    }
};


export const PSBServices = {
    getPSB
};